import { List, Map, OrderedMap } from 'immutable'
import * as actionTypes from './actionTypes'

const initialState = Map({
    all: Map({
        objects: [],
        fetching: false,
        error: null,
    }),
    setTransportPrices: Map({
        inProgress: false,
        error: null,
    }),
    uploadTransportsFile: Map({
        inProgress: false,
        error: null,
        transportsIds: []
    }),
})

function reportTransportInvoicing(state = initialState, action) {
    switch (action.type) {
        // List
        case actionTypes.FETCH_STARTED:
            return state.setIn(['all', 'fetching'], true)
        case actionTypes.FETCH_FULFILLED:
            return state.withMutations(map => {
                map
                    .setIn(['all', 'objects'], action.payload.data)
                    .setIn(['all', 'fetching'], false)
                    .setIn(['all', 'error'], null)
            })
        case actionTypes.FETCH_REJECTED:
            return state.withMutations(map => {
                map.setIn(['all', 'fetching'], false).setIn(['all', 'error'], action.payload)
            })
        case actionTypes.FETCH_CANCELLED:
            return state.setIn(['all', 'fetching'], false)

        // Clear
        case actionTypes.CLEAR:
            return state.setIn(['all', 'objects'], OrderedMap({}))

        default:
            return state

        // Set transport prices
        case actionTypes.SET_TRANSPORT_PRICES_STARTED:
            return state.setIn(['setTransportPrices', 'inProgress'], true)
        case actionTypes.SET_TRANSPORT_PRICES_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['setTransportPrices', 'inProgress'], false)
                .setIn(['setTransportPrices', 'error'], null)
                .setIn(['all', 'objects'], action.payload.data)
            })
        case actionTypes.SET_TRANSPORT_PRICES_REJECTED:
            return state.withMutations(map => {
                map.setIn(['setTransportPrices', 'inProgress'], false).setIn(['setTransportPrices', 'error'], action.payload)
            })

        // Upload transports file

        case actionTypes.UPLOAD_TRANSPORTS_FILE_STARTED:
            return state.setIn(['uploadTransportsFile', 'inProgress'], true)
        case actionTypes.UPLOAD_TRANSPORTS_FILE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['uploadTransportsFile', 'transportsIds'], action.payload)
                map.setIn(['uploadTransportsFile', 'inProgress'], false)
                map.setIn(['uploadTransportsFile', 'error'], null)
            })
        case actionTypes.UPLOAD_TRANSPORTS_FILE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['uploadTransportsFile', 'inProgress'], false).setIn(['uploadTransportsFile', 'error'], action.payload)
            })
        case actionTypes.UPLOAD_TRANSPORTS_FILE_CANCELLED:
            return state.setIn(['uploadTransportsFile', 'inProgress'], false)
    }
}

export default reportTransportInvoicing
